// Microsoft Clarity Analytics Script
// Clarity Tag ID: uglab1m3s8

(function(c,l,a,r,i,t,y){
  c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
  t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
  y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
})(window, document, "clarity", "script", "uglab1m3s8");

// Wait for Clarity to load and identify user with amp_device_id
(function() {
  try {
    // Function to identify user with Clarity
    var identifyUser = function() {
      // Get amp_device_id from URL parameters
      var uid = null;
      try {
        var urlParams = new URLSearchParams(window.location.search);
        uid = urlParams.get('amp_device_id');
      } catch (e) {
        console.warn('Error parsing URL parameters:', e);
      }
      
      // Fallback to localStorage if URL parameter not found
      var amp_device_id = uid;
      if (!amp_device_id && window.localStorage) {
        try {
          amp_device_id = window.localStorage.getItem('amp_device_id') || '';
        } catch (e) {
          console.warn('Error accessing localStorage:', e);
        }
      }
      
      // Identify user with Clarity if device ID exists
      if (amp_device_id && typeof window !== 'undefined' && window.clarity) {
        window.clarity('identify', amp_device_id);
        console.log('Clarity user identified:', amp_device_id);
      }
    };
    
    // Try to identify immediately if Clarity is already loaded
    if (window.clarity) {
      identifyUser();
    } else {
      // Otherwise wait for Clarity to load
      var checkClarityLoaded = setInterval(function() {
        if (window.clarity) {
          clearInterval(checkClarityLoaded);
          identifyUser();
        }
      }, 100);
      
      // Stop checking after 10 seconds
      setTimeout(function() {
        clearInterval(checkClarityLoaded);
      }, 10000);
    }
  } catch (error) {
    console.warn('Error initializing Clarity:', error);
  }
})();

/**
 * Send custom event data to Microsoft Clarity
 * @param {string} eventName - The name of the event to track
 * @param {Object} additionalData - Optional key-value pairs of additional data to send
 * 
 * @example
 * // Simple event
 * sendClarityData('add_to_cart');
 * 
 * @example
 * // Event with additional data
 * sendClarityData('product_view', {
 *   product_id: '12345',
 *   product_name: 'Halo Board',
 *   price: '499.99',
 *   category: 'electric-skateboards'
 * });
 */
window.sendClarityData = function(eventName, additionalData) {
  if (typeof window !== 'undefined' && window.clarity) {
    try {
      // Send the custom event
      window.clarity('event', eventName);
      console.log('Clarity event sent:', eventName);
      
      // If additional data is provided, send it as custom tags
      if (additionalData && typeof additionalData === 'object') {
        Object.keys(additionalData).forEach(function(key) {
          var value = additionalData[key];
          
          // Convert arrays and objects to strings, keep primitives as-is
          if (Array.isArray(value)) {
            window.clarity('set', key, value);
          } else {
            window.clarity('set', key, String(value));
          }
        });
        console.log('Clarity custom data sent:', additionalData);
      }
    } catch (error) {
      console.warn('Error sending Clarity data:', error);
    }
  } else {
    console.warn('Clarity not loaded. Event not sent:', eventName);
  }
};
